import usePurgeOrders from '../hooks/usePurgeOrders'
import usePollOrders from '../hooks/usePollOrders'
import useDispatchInitialActions from '../hooks/useDispatchInitialActions'
import useWatchBusinessHours from '../hooks/useWatchBusinessHours'
import useIdleRefresh from '../hooks/useIdleRefresh'

const Hooks = () => {
  usePurgeOrders()
  usePollOrders()
  useDispatchInitialActions()
  useWatchBusinessHours()
  useIdleRefresh()

  return null
}

export default Hooks
